declare global {
  interface Date {
    toJalaliDateTime(format?: string): string;
    toGeorgianDateString(): string;
  }
}

type _FormatPartType = "yyyy" | "yy" | "MMMM" | "MM" | "dd" | "HH" | "mm" | "ss" | "d";

const _mapFormatPart = (date: Date): Record<_FormatPartType, string> => ({
  yyyy: date.toLocaleDateString("fa", {
    year: "numeric",
  }),
  yy: date.toLocaleDateString("fa", {
    year: "2-digit",
  }),
  MMMM: `‎${date.toLocaleDateString("fa", {
    month: "long",
  })}‎`,
  MM: date.toLocaleDateString("fa", {
    month: "2-digit",
  }),
  dd: date.toLocaleDateString("fa", {
    day: "2-digit",
  }),
  d: date.toLocaleDateString("fa", {
    day: "numeric",
  }),
  HH: date.toLocaleTimeString("fa", {
    hour: "2-digit",
  }),
  mm: date.toLocaleTimeString("fa", {
    minute: "2-digit",
  }),
  ss: date.toLocaleTimeString("fa", {
    second: "2-digit",
  }),
});

Date.prototype.toJalaliDateTime = function (format?: string) {
  format ??= "HH:mm - yyyy/MM/dd";

  const dividers = format
    .split(/(yyyy|yy|MMMM|MM|dd|d|HH|mm|ss)/g)
    .filter((part) => part.match(/[^YyMdHms]/) && part !== "");

  return format
    .replace(/[^YyMdHms]/g, " ")
    .replace(/\s+/g, " ")
    .split(" ")
    .map((part) => (_mapFormatPart(this)[part as _FormatPartType] || "e").padStart(2, "0"))
    .map((value, index) => `${value}${dividers[index] || ""}`)
    .join("")
    .toEnglishDigits();
};

Date.prototype.toGeorgianDateString = function () {
  const year = this.getFullYear();
  const month = String(this.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(this.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export {};
